import { render, staticRenderFns } from "./SettingsControls.vue?vue&type=template&id=ddfdc992&"
import script from "./SettingsControls.vue?vue&type=script&lang=js&"
export * from "./SettingsControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddfdc992')) {
      api.createRecord('ddfdc992', component.options)
    } else {
      api.reload('ddfdc992', component.options)
    }
    module.hot.accept("./SettingsControls.vue?vue&type=template&id=ddfdc992&", function () {
      api.rerender('ddfdc992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/SettingsControls.vue"
export default component.exports